import { render, staticRenderFns } from "./NavigationPlugin.vue?vue&type=template&id=c3f64d8e&scoped=true"
import script from "./NavigationPlugin.vue?vue&type=script&lang=ts"
export * from "./NavigationPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./NavigationPlugin.vue?vue&type=style&index=0&id=c3f64d8e&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c3f64d8e",
  null
  ,true
)

export default component.exports